import React from 'react';
import { useTranslation } from 'react-i18next';
import { 
  ProviderOptionsType, 
  AnthropicOptionsInterface,
  OpenAIOptionsInterface,
  MistralOptionsInterface,
  GeminiOptionsInterface,
  OpenRouterOptionsInterface
} from '../../../app/interfaces/ProviderOptionsInterface';
import AnthropicOptions from './providerSpecific/AnthropicOptions';
import OpenAIOptions from './providerSpecific/OpenAIOptions';
import MistralOptions from './providerSpecific/MistralOptions';
import GeminiOptions from './providerSpecific/GeminiOptions';
import OpenRouterOptions from './providerSpecific/OpenRouterOptions';

export interface ProviderOptionsProps {
  /**
   * Current provider type (anthropic, openai, mistral, etc.)
   */
  provider: string;
  
  /**
   * Current provider options
   */
  options: ProviderOptionsType;
  
  /**
   * Callback for when options are changed
   */
  onOptionsChange: (options: ProviderOptionsType) => void;
}

export const ProviderOptions: React.FunctionComponent<ProviderOptionsProps> = (props: ProviderOptionsProps) => {
  const { provider, options, onOptionsChange } = props;
  const { t } = useTranslation();

  /**
   * Renders the appropriate options component based on the current provider
   */
  const renderProviderOptions = () => {
    switch (provider) {
      case 'anthropic':
        return (
          <AnthropicOptions 
            options={options as AnthropicOptionsInterface} 
            onChange={onOptionsChange} 
          />
        );
      case 'openai':
        return (
          <OpenAIOptions 
            options={options as OpenAIOptionsInterface} 
            onChange={onOptionsChange} 
          />
        );
      case 'mistral':
        return (
          <MistralOptions 
            options={options as MistralOptionsInterface} 
            onChange={onOptionsChange} 
          />
        );
      case 'google':
        return (
          <GeminiOptions 
            options={options as GeminiOptionsInterface} 
            onChange={onOptionsChange} 
          />
        );
      case 'openrouter':
        return (
          <OpenRouterOptions 
            options={options as OpenRouterOptionsInterface} 
            onChange={onOptionsChange} 
          />
        );
      default:
        return (
          <div className="p-4 text-center">
            {t('provider_options.no_options_available')}
          </div>
        );
    }
  };

  return (
    <div className="provider-options">
      <h3 className="text-xl mb-3">{t('provider_options.title')}</h3>
      {renderProviderOptions()}
    </div>
  );
};

export default ProviderOptions;